import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

const useQueryParams = <QueryParams>(): QueryParams => {
  const { search } = useLocation();

  return queryString.parse(search.replace('?', ''), {
    parseBooleans: true,
  }) as unknown as QueryParams;
};

export default useQueryParams;
